import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, HStack, Text, VStack } from '@chakra-ui/react'
import { usePin, useShareVehicle, useVehicles } from 'context'
import { isEmpty } from 'lodash'
import { primaryColor } from 'theme/foundations/primaryColor'

import { CardBody, CardContainer } from 'components/CustomCard'

import { AddIcon, InfoIcon } from '../../components/SVGS/newIcons'

import { SharedContactItem } from './SharedContactItem'

export const DetailShareVehicle = () => {
  const navigate = useNavigate()
  const { shareVehicleState: { loading, state: { contactsShareVehicles } } } = useShareVehicle()
  const { pinState: { state: { isHavePin } } } = usePin()
  const { vehicleState: { state: { vehicle } } } = useVehicles()
  const { icon: { secondaryIconColor, infoIconColor } } = primaryColor

  const handleGoBack = useCallback(() => {
    navigate('/my-vehicles')
  }, [navigate])

  const handleValidateRoute = useCallback(() => {
    isEmpty(contactsShareVehicles) && handleGoBack()
  }, [contactsShareVehicles, handleGoBack])

  useEffect(() => {
    handleValidateRoute()
  }, [handleValidateRoute])

  const handleShareVehicle = () => {
    if (!isHavePin)
      navigate('/create-pin')
    else if (contactsShareVehicles.length < 4)
      navigate('/confirm-to-pin', {
        state: {
          params: {
            previousRoute: 'VEHICLE',
            text: 'Para compartir tu vehículo debes ingresar tu PIN',
            textButton: 'Ingresar',
            vehicleInfo: vehicle,
          }
        }
      })
  }


  return (
    <CardContainer isScreen hiddenStack={false} onClose={handleGoBack} headerText={'Compartidos'}>
      <CardBody maxW={{ base: 'full', md: '550px' }}>
        <VStack w={'full'}>
          {contactsShareVehicles.map(contact => (
            <SharedContactItem key={contact.id} contact={contact} idVehicle={vehicle?.id} item={vehicle} />
          ))}
          <HStack w={'full'}>
            <InfoIcon fill={infoIconColor} />
            <Text>Recuerda que solo puedes compartir tu  auto con 4 personas</Text>
          </HStack>
          <Button
            w={'90%'}
            disabled={loading || contactsShareVehicles.length > 3}
            loadingText={'Eliminando...'}
            isLoading={loading}
            leftIcon={<AddIcon fill={secondaryIconColor} />}
            onClick={handleShareVehicle}
          >
            Agregar
          </Button>
        </VStack>
      </CardBody>
    </CardContainer>
  )
}
